import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ModalService } from 'src/app/services/modal.service';
import { AppConstants } from 'src/app/settings/app-constants';

@Component({
    selector: 'app-safe-summary-details',
    templateUrl: './safe-summary-details.component.html',
    styleUrls: ['./safe-summary-details.component.css'],
})
export class SafeSummaryDetailsComponent {
    @Input() safeSummary: any;
    @Output() event = new EventEmitter<boolean>();

    dateFormat = AppConstants.DATE_FORMAT;

    constructor(private modalService: ModalService) { }

    closeViewModel() {
        this.event.emit(false);
    }

    openModal(id: string) {
        this.modalService.open(id);
    }
}
